import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "viewBox": "-7.5 -8 2154.40625 409.6302185058594",
        "style": {
          "maxWidth": "2154.40625px"
        },
        "aria-labelled-by": ["chart-title-mermaid-1673394042829", "chart-desc-mermaid-1673394042829"],
        "role": "img",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "100%",
        "id": "mermaid-1673394042829"
      }}><title parentName="svg" {...{
          "id": "chart-title-mermaid-1673394042829"
        }}></title><desc parentName="svg" {...{
          "id": "chart-desc-mermaid-1673394042829"
        }}></desc><style parentName="svg">{`#mermaid-1673394042829 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1673394042829 .error-icon{fill:#552222;}#mermaid-1673394042829 .error-text{fill:#552222;stroke:#552222;}#mermaid-1673394042829 .edge-thickness-normal{stroke-width:2px;}#mermaid-1673394042829 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1673394042829 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1673394042829 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1673394042829 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1673394042829 .marker{fill:#333333;stroke:#333333;}#mermaid-1673394042829 .marker.cross{stroke:#333333;}#mermaid-1673394042829 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1673394042829 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1673394042829 .cluster-label text{fill:#333;}#mermaid-1673394042829 .cluster-label span{color:#333;}#mermaid-1673394042829 .label text,#mermaid-1673394042829 span{fill:#333;color:#333;}#mermaid-1673394042829 .node rect,#mermaid-1673394042829 .node circle,#mermaid-1673394042829 .node ellipse,#mermaid-1673394042829 .node polygon,#mermaid-1673394042829 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1673394042829 .node .label{text-align:center;}#mermaid-1673394042829 .node.clickable{cursor:pointer;}#mermaid-1673394042829 .arrowheadPath{fill:#333333;}#mermaid-1673394042829 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1673394042829 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1673394042829 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1673394042829 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1673394042829 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1673394042829 .cluster text{fill:#333;}#mermaid-1673394042829 .cluster span{color:#333;}#mermaid-1673394042829 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1673394042829 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1673394042829 .sgraph>*{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1673394042829 .sgraph span{fill:#fff!important;stroke-width:3px!important;stroke-dasharray:5!important;stroke:#000!important;}#mermaid-1673394042829 .plain>*{fill:#ddd!important;stroke:#fff!important;stroke-width:4px!important;color:#000!important;}#mermaid-1673394042829 .plain span{fill:#ddd!important;stroke:#fff!important;stroke-width:4px!important;color:#000!important;}#mermaid-1673394042829 .k8s>*{fill:#326ce5!important;stroke:#fff!important;stroke-width:4px!important;color:#fff!important;}#mermaid-1673394042829 .k8s span{fill:#326ce5!important;stroke:#fff!important;stroke-width:4px!important;color:#fff!important;}#mermaid-1673394042829 .cluster>*{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}#mermaid-1673394042829 .cluster span{fill:#fff!important;stroke:#bbb!important;stroke-width:2px!important;color:#326ce5!important;}`}</style><g parentName="svg"><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "9",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 0 L 10 5 L 0 10 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "12",
            "markerWidth": "12",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "0",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-pointStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 0 5 L 10 10 L 10 0 z"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "11",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleEnd"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5",
            "refX": "-1",
            "viewBox": "0 0 10 10",
            "className": "marker flowchart",
            "id": "flowchart-circleStart"
          }}><circle parentName="marker" {...{
              "style": {
                "strokeWidth": "1",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "r": "5",
              "cy": "5",
              "cx": "5"
            }}></circle></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "12",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossEnd"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><marker parentName="g" {...{
            "orient": "auto",
            "markerHeight": "11",
            "markerWidth": "11",
            "markerUnits": "userSpaceOnUse",
            "refY": "5.2",
            "refX": "-1",
            "viewBox": "0 0 11 11",
            "className": "marker cross flowchart",
            "id": "flowchart-crossStart"
          }}><path parentName="marker" {...{
              "style": {
                "strokeWidth": "2",
                "strokeDasharray": "1, 0"
              },
              "className": "arrowMarkerPath",
              "d": "M 1,1 l 9,9 M 10,1 l -9,9"
            }}></path></marker><g parentName="g" {...{
            "className": "root"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "transform": "translate(-7.5, -8)",
                "className": "root"
              }}><g parentName="g" {...{
                  "className": "clusters"
                }}><g parentName="g" {...{
                    "id": "Wrapper",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "393.6302146911621",
                      "width": "2138.40625",
                      "y": "8",
                      "x": "8",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1077.203125, 13)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "PluginServerIngestion",
                    "className": "cluster default"
                  }}><rect parentName="g" {...{
                      "height": "353.6302146911621",
                      "width": "1147.015625",
                      "y": "28",
                      "x": "491.0625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1064.5703125, 33)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "MainThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "313.6302146911621",
                      "width": "196.109375",
                      "y": "48",
                      "x": "516.0625",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(566.25, 53)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "95.734375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Main thread`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "id": "WorkerThread",
                    "className": "cluster sgraph"
                  }}><rect parentName="g" {...{
                      "height": "188",
                      "width": "730.640625",
                      "y": "121.63021469116211",
                      "x": "882.4375",
                      "ry": "0",
                      "rx": "0",
                      "style": {}
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(1190.8046875, 126.63021469116211)",
                      "className": "cluster-label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "113.90625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Worker thread`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "edgePaths"
                }}><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Django LE-Kafka",
                    "id": "L-Django-Kafka-0",
                    "d": "M85.2903769756427,179.81510734558105L92.68468914636891,187.45095856984457C100.07900131709512,195.08680979410806,114.86762565854757,210.3585122426351,126.51193782927379,218.07769680023193C138.15625,225.79688135782877,146.65625,225.96354802449545,150.90625,226.04688135782877L155.15625,226.1302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Django LE-Redis",
                    "id": "L-Django-Redis-0",
                    "d": "M85.2903769756427,145.81510734558105L92.68468914636891,138.17925612131754C100.07900131709512,130.54340489705405,114.86762565854757,115.27170244852702,129.36610449594045,107.6358512242635C143.86458333333334,100,158.07291666666666,100,165.17708333333334,100L172.28125,100"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Redis LE-PubSub",
                    "id": "L-Redis-PubSub-0",
                    "d": "M230.46875,100L253.65364583333334,100C276.8385416666667,100,323.2083333333333,100,366.640625,100C410.0729166666667,100,450.5677083333333,100,474.9817708333333,100C499.3958333333333,100,507.7291666666667,100,521.9778645833334,100C536.2265625,100,556.390625,100,566.47265625,100L576.5546875,100"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PubSub LE-Piscina",
                    "id": "L-PubSub-Piscina-0",
                    "d": "M651.6796875,100L661.76171875,100C671.84375,100,692.0078125,100,706.2565104166666,100C720.5052083333334,100,728.8385416666666,100,741.5538854282422,116.43836911519368C754.2692291898178,132.87673823038736,771.3665833796355,165.75347646077475,779.9152604745444,182.19184557596842L788.4639375694533,198.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-ReloadPlugins",
                    "id": "L-Piscina-ReloadPlugins-0",
                    "d": "M821.6441592261905,198.6302146911621L827.6097160218254,194.46354802449545C833.5752728174602,190.29688135782877,845.5063864087301,181.96354802449545,855.6386098710318,177.79688135782877C865.7708333333334,173.6302146911621,874.1041666666666,173.6302146911621,886.35546875,173.6302146911621C898.6067708333334,173.6302146911621,914.7760416666666,173.6302146911621,922.8606770833334,173.6302146911621L930.9453125,173.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Kafka LE-KafkaConsumer",
                    "id": "L-Kafka-KafkaConsumer-0",
                    "d": "M248.59375,226.1302146911621L268.7578125,226.04688135782877C288.921875,225.96354802449545,329.25,225.79688135782877,369.6614583333333,225.71354802449545C410.0729166666667,225.6302146911621,450.5677083333333,225.6302146911621,474.9817708333333,225.6302146911621C499.3958333333333,225.6302146911621,507.7291666666667,225.6302146911621,516.0625,225.6302146911621C524.3958333333334,225.6302146911621,532.7291666666666,225.6302146911621,536.8958333333334,225.6302146911621L541.0625,225.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-0",
                    "d": "M640.6542700258531,208.6302146911621L652.5738708548776,200.9943634668986C664.493471683902,193.3585122426351,688.3326733419511,178.08680979410806,704.4189408376423,170.45095856984457C720.5052083333334,162.81510734558105,728.8385416666666,162.81510734558105,739.8014428544756,168.7842919031779C750.7643440422844,174.75347646077475,764.3568130845687,186.69184557596842,771.1530476057109,192.66103013356528L777.949282126853,198.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-1",
                    "d": "M687.171875,225.6302146911621L691.3385416666666,225.6302146911621C695.5052083333334,225.6302146911621,703.8385416666666,225.6302146911621,712.171875,225.6302146911621C720.5052083333334,225.6302146911621,728.8385416666666,225.6302146911621,737.171875,224.93730403333007C745.5052083333334,224.24439337549802,753.8385416666666,222.8585720598339,758.0052083333334,222.16566140200186L762.171875,221.4727507441698"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none",
                      "strokeWidth": "2px",
                      "strokeDasharray": "3"
                    },
                    "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-KafkaConsumer LE-Piscina",
                    "id": "L-KafkaConsumer-Piscina-2",
                    "d": "M630.786484375,242.6302146911621L644.3507161458333,256.4635480244954C657.9149479166666,270.2968813578288,685.0434114583333,297.9635480244954,702.7743098958332,311.7968813578288C720.5052083333334,325.6302146911621,728.8385416666666,325.6302146911621,741.4784682765152,310.1302146911621C754.1183948863636,294.6302146911621,771.0649147727272,263.6302146911621,779.5381747159091,248.1302146911621L788.0114346590909,232.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Piscina LE-ProcessEvent",
                    "id": "L-Piscina-ProcessEvent-0",
                    "d": "M821.6441592261905,232.6302146911621L827.6097160218254,236.79688135782877C833.5752728174602,240.96354802449545,845.5063864087301,249.29688135782877,855.6386098710318,253.46354802449545C865.7708333333334,257.6302146911621,874.1041666666666,257.6302146911621,882.4375,257.6302146911621C890.7708333333334,257.6302146911621,899.1041666666666,257.6302146911621,903.2708333333334,257.6302146911621L907.4375,257.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-ProcessEvent LE-PrepareEvent",
                    "id": "L-ProcessEvent-PrepareEvent-0",
                    "d": "M1086.796875,257.6302146911621L1090.9635416666667,257.6302146911621C1095.1302083333333,257.6302146911621,1103.4635416666667,257.6302146911621,1111.796875,257.6302146911621C1120.1302083333333,257.6302146911621,1128.4635416666667,257.6302146911621,1132.6302083333333,257.6302146911621L1136.796875,257.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-PrepareEvent LE-EmitToBuffer",
                    "id": "L-PrepareEvent-EmitToBuffer-0",
                    "d": "M1259.890625,257.6302146911621L1264.0572916666667,257.6302146911621C1268.2239583333333,257.6302146911621,1276.5572916666667,257.6302146911621,1284.890625,257.6302146911621C1293.2239583333333,257.6302146911621,1301.5572916666667,257.6302146911621,1305.7239583333333,257.6302146911621L1309.890625,257.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-EmitToBuffer LE-CreateEvent",
                    "id": "L-EmitToBuffer-CreateEvent-0",
                    "d": "M1426.453125,257.6302146911621L1430.6197916666667,257.6302146911621C1434.7864583333333,257.6302146911621,1443.1197916666667,257.6302146911621,1451.453125,257.6302146911621C1459.7864583333333,257.6302146911621,1468.1197916666667,257.6302146911621,1472.2864583333333,257.6302146911621L1476.453125,257.6302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-CreateEvent LE-Kafka2",
                    "id": "L-CreateEvent-Kafka2-0",
                    "d": "M1588.078125,257.6302146911621L1592.2447916666667,257.6302146911621C1596.4114583333333,257.6302146911621,1604.7447916666667,257.6302146911621,1613.078125,257.6302146911621C1621.4114583333333,257.6302146911621,1629.7447916666667,257.6302146911621,1653.6302083333333,257.6302146911621C1677.515625,257.6302146911621,1716.953125,257.6302146911621,1756.4739583333333,257.7135480244954C1795.9947916666667,257.7968813578288,1835.5989583333333,257.9635480244954,1855.4010416666667,258.0468813578288L1875.203125,258.1302146911621"
                  }}></path><path parentName="g" {...{
                    "markerEnd": "url(#flowchart-pointEnd)",
                    "style": {
                      "fill": "none"
                    },
                    "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Kafka2 LE-ClickHouse",
                    "id": "L-Kafka2-ClickHouse-0",
                    "d": "M1968.640625,258.1302146911621L1972.7239583333333,258.0468813578288C1976.8072916666667,257.9635480244954,1984.9739583333333,257.7968813578288,1993.2239583333333,257.7135480244954C2001.4739583333333,257.6302146911621,2009.8072916666667,257.6302146911621,2013.9739583333333,257.6302146911621L2018.140625,257.6302146911621"
                  }}></path></g><g parentName="g" {...{
                  "className": "edgeLabels"
                }}><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(369.578125, 225.6302146911621)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-96.484375, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "192.96875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`events_plugin_ingestion`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1756.390625, 257.6302146911621)",
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(-93.3125, -9.5)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "186.625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}>{`clickhouse_events_json`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "className": "edgeLabel"
                  }}><g parentName="g" {...{
                      "transform": "translate(0, 0)",
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "0",
                        "width": "0"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "edgeLabel"
                          }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                  "className": "nodes"
                }}><g parentName="g" {...{
                    "transform": "translate(201.375, 100)",
                    "id": "flowchart-Redis-94",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-29.09375,-28.911463664278404)",
                      "d": "M 0,7.940975776185602 a 29.09375,7.940975776185602 0,0,0 58.1875 0 a 29.09375,7.940975776185602 0,0,0 -58.1875 0 l 0,41.9409757761856 a 29.09375,7.940975776185602 0,0,0 58.1875 0 l 0,-41.9409757761856",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-21.59375, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "43.1875"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Redis`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(68.828125, 162.81510734558105)",
                    "id": "flowchart-Django-98",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "71.65625",
                      "y": "-17",
                      "x": "-35.828125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-28.328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "56.65625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Django`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(201.375, 225.6302146911621)",
                    "id": "flowchart-Kafka-96",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(614.1171875, 100)",
                    "id": "flowchart-PubSub-101",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "75.125",
                      "y": "-17",
                      "x": "-37.5625",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-30.0625, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "60.125"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`PubSub`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(797.3046875, 215.6302146911621)",
                    "id": "flowchart-Piscina-102",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "70.265625",
                      "y": "-17",
                      "x": "-35.1328125",
                      "ry": "0",
                      "rx": "0",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-27.6328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "55.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Piscina`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(997.1171875, 173.6302146911621)",
                    "id": "flowchart-ReloadPlugins-110",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "132.34375",
                      "y": "-17",
                      "x": "-66.171875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-58.671875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "117.34375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Reload plugins`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(614.1171875, 225.6302146911621)",
                    "id": "flowchart-KafkaConsumer-99",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "146.109375",
                      "y": "-17",
                      "x": "-73.0546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-65.5546875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "131.109375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka Consumer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(997.1171875, 257.6302146911621)",
                    "id": "flowchart-ProcessEvent-106",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "179.359375",
                      "y": "-17",
                      "x": "-89.6796875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-82.1796875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "164.359375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`pluginsProcessEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1198.34375, 257.6302146911621)",
                    "id": "flowchart-PrepareEvent-107",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "123.09375",
                      "y": "-17",
                      "x": "-61.546875",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-54.046875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "108.09375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`prepareEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1368.171875, 257.6302146911621)",
                    "id": "flowchart-EmitToBuffer-108",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "116.5625",
                      "y": "-17",
                      "x": "-58.28125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-50.78125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "101.5625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`emitToBuffer`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1532.265625, 257.6302146911621)",
                    "id": "flowchart-CreateEvent-109",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "111.625",
                      "y": "-17",
                      "x": "-55.8125",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-48.3125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "96.625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`createEvent`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(1921.421875, 257.6302146911621)",
                    "id": "flowchart-Kafka2-97",
                    "className": "node default default"
                  }}><polygon parentName="g" {...{
                      "style": {},
                      "transform": "translate(-46.71875,46.71875)",
                      "className": "label-container",
                      "points": "46.71875,0 93.4375,-46.71875 46.71875,-93.4375 0,-46.71875"
                    }}></polygon><g parentName="g" {...{
                      "transform": "translate(-22.21875, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "44.4375"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`Kafka`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(2069.7734375, 257.6302146911621)",
                    "id": "flowchart-ClickHouse-95",
                    "className": "node default default"
                  }}><path parentName="g" {...{
                      "transform": "translate(-51.6328125,-33.96471353275378)",
                      "d": "M 0,11.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 a 51.6328125,11.309809021835854 0,0,0 -103.265625 0 l 0,45.309809021835854 a 51.6328125,11.309809021835854 0,0,0 103.265625 0 l 0,-45.309809021835854",
                      "style": {}
                    }}></path><g parentName="g" {...{
                      "transform": "translate(-44.1328125, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "88.265625"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`ClickHouse`}</span></div></foreignObject></g></g><g parentName="g" {...{
                    "transform": "translate(614.1171875, 309.6302146911621)",
                    "id": "flowchart-HttpServer-100",
                    "className": "node default default"
                  }}><rect parentName="g" {...{
                      "height": "34",
                      "width": "113.5",
                      "y": "-17",
                      "x": "-56.75",
                      "ry": "5",
                      "rx": "5",
                      "style": {},
                      "className": "basic label-container"
                    }}></rect><g parentName="g" {...{
                      "transform": "translate(-49.25, -9.5)",
                      "style": {},
                      "className": "label"
                    }}><foreignObject parentName="g" {...{
                        "height": "19",
                        "width": "98.5"
                      }}><div parentName="foreignObject" {...{
                          "style": {
                            "display": "inline-block",
                            "whiteSpace": "nowrap"
                          },
                          "xmlns": "http://www.w3.org/1999/xhtml"
                        }}><span parentName="div" {...{
                            "className": "nodeLabel"
                          }}>{`HTTP Server`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      